import Ajax from '../ajax';

export default {
  list: () => Ajax('get', 'swapout/productCategory'),
  get: (catId) => Ajax('get', `swapout/productCategory/${catId}`),
  add: (data) => Ajax('post', 'swapout/productCategory', data),
  edit: (catId, data) => Ajax('put', `swapout/productCategory/${catId}`, data),
  delete: (catId) => Ajax('delete', `swapout/productCategory/${catId}`),
};
